import React, { Component } from 'react';
import { PageDescription } from '../..';
import PageBaseLayoutWithTwoButtons from '../../Common/PageBaseLayoutWithTwoButtons';
import { getData, BreadTreeElement } from '../../../utils/PageApi';
import { buttonText } from '../../../constants/buttonText';
import { buttonComment } from '../../../constants/buttonComment';
import { BottomSectionText } from '../../../constants/BottomSectionText';
import { FormDiv } from './ContactStyle';
import SendButton from './SendButton';
import color from '../../colors';
import './Contact.css';

type PageDateType = {
  title: { rendered: string };
  link: string;
  featured_media: number;
  acf: {
    metaDescription: string;
    heroImg: string;
    subtitle: string;
    pageDescription: string;
    formId: string;
  };
  slug: string;
  parent: number;
};

interface OwnProps {}
interface OwnState {
  data: PageDateType;
  breadTreeElements: BreadTreeElement[];
}

class Contact extends Component<OwnProps, OwnState> {
  constructor(ownProps: any, ownState: any) {
    super(ownProps, ownState);
    this.state = {
      data: {
        title: { rendered: '' },
        link: '',
        featured_media: 0,
        acf: {
          metaDescription: '',
          heroImg: '',
          subtitle: '',
          pageDescription: '',
          formId: '',
        },
        slug: '',
        parent: 0,
      },
      breadTreeElements: [],
    };
  }

  async create() {
    let pageId = 1339;
    const state = await getData<PageDateType>(pageId);
    this.setState(state);
  }
  componentDidMount() {
    this.create();
  }
  render() {
    let data = this.state.data;
    let dataAcf = data.acf;
    let title = data.title.rendered;
    return (
      <PageBaseLayoutWithTwoButtons
        metaDescription={dataAcf.metaDescription}
        BreadTreeElements={this.state.breadTreeElements}
        heroImgURL={dataAcf.heroImg}
        title={title}
        subTitle={dataAcf.subtitle}
        eyeCatchId={data.featured_media}
        ogLink={data.link}
        bottomSectionTitle={BottomSectionText.pattern2}
        bottomSectionText={BottomSectionText.pattern3}
        bottomButtonLink={'https://liff.line.me/2008104550-xDDbnzJw/landing?follow=%40zlf8066v&lp=iuVMrU&liff_id=2008104550-xDDbnzJw'}
        bottomSectionColor={color.lightGray}
        bottomButtonComment={buttonComment.hoiku}
        bottomButtonText={buttonText.here}
        bottomButtonSize={'23.7rem'}
        bottomButtonClass={'hoiku-button'}
        bottomButtonText2={buttonText.here}
        bottomButtonComment2={buttonComment.frog}
        bottomButtonLink2={'https://line.me/R/ti/p/@704gfaml?oat_content=url&ts=07311452'}
        bottomButtonSize2={'23.7rem'}
        bottomButtonClass2={'frog-button'}
      >
        <PageDescription>
          <div dangerouslySetInnerHTML={{ __html: dataAcf.pageDescription }} />
        </PageDescription>
        <FormDiv dangerouslySetInnerHTML={{ __html: dataAcf.formId }} />
        {dataAcf.formId && <SendButton />}
      </PageBaseLayoutWithTwoButtons>
    );
  }
}
export default Contact;
